module.exports = __webpack_public_path__ + "img/pin-aguasfecales.5711b11a.png";